export default {
  items: [
    {
      name: 'Dashboard (a)',
      url: '/Newport',
      icon: 'icon-speedometer'
    },
    {
      divider: true
    },

    // {
    // name: 'Admin',
    // icon: 'icon-equalizer',
    // children: [
    {
      name: 'Location',
      url: '/base/locations/',
      icon: 'icon-location-pin'
    },
    {
      name: 'All Lock',
      url: '/base/locks/',
      icon: 'icon-lock'
    },
    {
      name: 'Manager',
      url: '/base/manager/',
      icon: 'icon-people'
    },
    {
      name: 'Statistic (a)',
      url: '/base/statistics/',
      icon: 'icon-chart'
    }
    // ]
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js